export enum MemberBulkActions {
    Activate = "activate",
    Deactivate = "deactivate",
    Suspend = "suspend",
    Unsuspend = "unsuspend",
    Delete = "delete",
    Invite = "invite",
    Uninvite = "uninvite"
}

export enum UserBulkActions {
    Activate = "activate",
    Deactivate = "deactivate"
}

export enum PropertyBulkActions {
    Activate = "activate",
    Deactivate = "deactivate",
    Delete = "delete"
}

export enum ChargeBulkActions {
    WaiveLateFees = "waive_late_fees"
}